import { Link } from 'react-router-dom';
import useAuditProgress from './useAuditProgress';
import useMediaQuery from '../../shared/useMediaQuery';
import '../../../styles/AuditProgress.css';

// Sur téléphone le bandeau prend de la place pour peu d'intérêt : on ne l'affiche
// pas, et on évite du même coup l'appel (recalculé à chaque fois) à /get_audit_progress.
export default function AuditProgressBar(props) {
    const isPhone = useMediaQuery('(max-width: 640px)');
    if (isPhone) return null;
    return <AuditProgressBarContent {...props} />;
}

function AuditProgressBarContent({ buildingId, clientId }) {
    const { progress, loading, error } = useAuditProgress(buildingId);

    if (loading || error || !progress) return null;

    const progressLink = clientId
        ? `/client/${clientId}/${buildingId}/progress`
        : `/client/${buildingId}/progress`;

    return (
        <div className="audit-progress-bar">
            <span className="audit-progress-bar-percent">Suivi audit : {progress.global_percent}%</span>
            <div className="audit-progress-bar-track">
                <div className="audit-progress-bar-fill" style={{ width: `${progress.global_percent}%` }} />
            </div>
            {progress.warnings_count > 0 && (
                <span className="audit-progress-bar-warnings">
                    <span className="audit-progress-bar-warnings-dot" />
                    {progress.warnings_count}
                </span>
            )}
            <Link className="audit-progress-bar-link" to={progressLink}>Voir le suivi complet →</Link>
        </div>
    );
}
